/** Ile znaków nazwy zostaje przed rozszerzeniem, gdy jest na nie miejsce. */
const TAIL_CONTEXT_LENGTH = 4;

/** Ogon nigdy się nie skraca, więc nie może zjeść całej szerokości komórki. */
const TAIL_MAX_LENGTH = 10;

export interface SplitFileName {
  /** Początek nazwy — to on jest ucinany, gdy zabraknie miejsca. */
  head: string;
  /** Końcówka z rozszerzeniem — zostaje widoczna zawsze. */
  tail: string;
}

/**
 * Dzieli nazwę pliku na część skracalną i nieskracalną, żeby ucięcie od środka
 * robił CSS. Ucinanie liczone w JS nie wie nic o szerokości kolumny: skraca
 * nazwę, która by się zmieściła, a po skróceniu komórka przestaje przepełniać
 * kontener, więc tooltip z pełną nazwą już się nie otwiera.
 *
 * Rozszerzenie zostaje w ogonie, bo to ono mówi, co użytkownik pobierze, razem
 * z kilkoma znakami przed nim — tam siedzi to, co odróżnia plik od sąsiadów.
 */
export const splitFileName = (fileName: string): SplitFileName => {
  const dotIndex = fileName.lastIndexOf('.');
  // Kropka na pozycji 0 to nazwa typu `.gitignore`, nie rozszerzenie.
  const hasExtension = dotIndex > 0;
  const extension = hasExtension ? fileName.slice(dotIndex) : '';
  const base = hasExtension ? fileName.slice(0, dotIndex) : fileName;

  const contextBudget = Math.max(
    0,
    Math.min(TAIL_CONTEXT_LENGTH, TAIL_MAX_LENGTH - extension.length),
  );
  // Przynajmniej jeden znak musi zostać w części skracalnej, inaczej nie ma
  // czego uciąć i cała nazwa staje się nieskracalna.
  const contextLength = Math.min(contextBudget, Math.max(0, base.length - 1));

  return {
    head: base.slice(0, base.length - contextLength),
    tail: `${base.slice(base.length - contextLength)}${extension}`,
  };
};
